import React from 'react';
import styles from './DeleteConfirmationModal.module.scss';

const DeleteConfirmationModal = ({ onCancel, onConfirm, isSubmitting }) => {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <h4>Confirm Deletion</h4>
        <p>Are you sure you want to delete this balance record?</p>
        <p>This action cannot be undone.</p>
        <div className={styles.modalActions}>
          <button 
            className={styles.cancelBtn} 
            onClick={onCancel}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button 
            className={styles.confirmDeleteBtn} 
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal; 